import { ChangeDetectorRef, Component, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DisplayMode } from 'cbc-shared-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  Sgke131aRequest, Sgke131aResponseBasicInfo, Sgke131aResponseBikoran,
  Sgke131aResponseKouzaDepositreportMeisai, Sgke131aResponseRcvmnyFeeMeisai,
  Sgke131aResponseReceivemoneyyoteiMeisaiList, Sgke131aResponseReconciliationResult,
  Sgke132aRequest, Sgke133aRequest
} from 'sg-api';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { CompleteDataService } from '../../../../../../sg-base/sg-base-shared/pages/sgkz003d/services/complete-data.service';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';
import { Sgke110dDialogComponent } from '../../../sgke110d/components/sgke110d-dialog/sgke110d-dialog.component';
import { Sgke140dDialogComponent } from '../../../sgke140d/components/sgke140d-dialog/sgke140d-dialog.component';
import { UsedSgke131aService } from '../../services/used-sgke131a.service';
import { UsedSgke132aService } from '../../services/used-sgke132a.service';
import { UsedSgke133aService } from '../../services/used-sgke133a.service';
import { UsedSgke122aService } from '../../../sgke120d/services/used-sgke122a.service';

@Component({
  selector: 'app-sgke130d',
  templateUrl: './sgke130d.component.html',
  styleUrl: './sgke130d.component.scss'
})
export class Sgke130dComponent implements OnInit, OnDestroy {

  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();
  /** 入金突合結果管理番号 */
  private rcvmnyReconciliationresultMno: string = null;

  /** モード区分_登録 */
  public MODE_CREATE = DisplayMode.create;
  /** モード区分_承認 */
  public MODE_APPROVE = DisplayMode.approve;

  /** 入金突合ステータス_未報告 */
  public RECONCILIATION_STATUSCODE_UNREPORTED = "0";
  /** 入金突合ステータス_報告済 */
  public RECONCILIATION_STATUSCODE_REPORTED = "1";
  /** 入金突合ステータス_承認済 */
  public RECONCILIATION_STATUSCODE_APPROVED = "2";

  /** モード区分（初期値として登録を設定） */
  mode: string = this.MODE_CREATE;
  /** 基本情報 */
  basicInfo: Sgke131aResponseBasicInfo;
  /** 突合結果 */
  reconciliationResult: Sgke131aResponseReconciliationResult;
  /** 入金予定明細リスト */
  receivemoneyyoteiMeisaiList: Array<Sgke131aResponseReceivemoneyyoteiMeisaiList>;
  /** 口座入金報告明細 */
  kouzaDepositreportMeisai: Sgke131aResponseKouzaDepositreportMeisai;
  /** 入金手数料明細 */
  rcvmnyFeeMeisai: Sgke131aResponseRcvmnyFeeMeisai;
  /** 備考欄 */
  bikoran: Sgke131aResponseBikoran;

  /** 親Form FormGroup */
  parentForm: UntypedFormGroup;
  /** エラーメッセージ表示フラグ */
  isErrMssageDisplay: boolean = true;
  /** 戻る画面フラグ */
  returnFlg: boolean = false;

  /**
   * コンストラクタ
   * @param {ActivatedRoute} route 
   * @param {Router} router 
   * @param {UsedSgke131aService} initService 
   * @param {UsedSgke132aService} reportService 
   * @param {UsedSgke133aService} approvalService 
   * @param {UsedSgke122aService} usedSgke122aService 
   * @param {UntypedFormBuilder} fb
   * @param {MatDialog} dialog 
   * @param {CompleteDataService} completeDataService 
   * @param {ResponseMsgUtils} responseMsgUtils
   * @param {ChangeDetectorRef} cd
   */
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public initService: UsedSgke131aService,
    public reportService: UsedSgke132aService,
    public approvalService: UsedSgke133aService,
    public usedSgke122aService: UsedSgke122aService,
    private fb: UntypedFormBuilder,
    public dialog: MatDialog,
    private completeDataService: CompleteDataService,
    public responseMsgUtils: ResponseMsgUtils,
    private cd: ChangeDetectorRef,
  ) {

  }

  /**
   * 初期処理
   * 
   * @memberof Sgke130dComponent
   */
  ngOnInit(): void {

    // 画面遷移元パラメータ取得
    this.mode = this.route.snapshot.paramMap.get('mode');
    this.rcvmnyReconciliationresultMno = this.route.snapshot.paramMap.get('rcvmnyReconciliationresultMno');

    // 親Formを初期化
    this.parentForm = this.fb.group({});

    // 初期処理
    this.init();

  }

  /**
   * コンポーネントが破棄される際に呼び出されるライフサイクルフック
   * リソースの解放や購読の解除
   * 
   * @memberof Sgke130dComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    // 戻るボタン以外は検索条件をクリアする
    if (!this.returnFlg) {
      this.usedSgke122aService.searchFormValue = null;
    }
  }

  /**
   * 入金通知報告画面遷移処理（金額登録／訂正ボタン押下時）
   * 
   * @param {boolean} isEdit
   * @memberof Sgke130dComponent
   */
  navigateToNoticeReportOnClickRegist(isEdit: boolean) {

    // メッセージクリア
    this.clearErrorMsg();

    /** ダイアログに渡すデータオブジェクト */
    let dataObject = {
      // 入金突合結果管理番号
      rcvmnyReconciliationresultMno: this.basicInfo.rcvmnyReconciliationresultMno || null,
      // 入金突合結果_更新通番号
      rcvmnyreconciliationResultUpdatesequencenumber: this.basicInfo.rcvmnyreconciliationResultUpdatesequencenumber || null,
      // 入金通知報告管理番号
      rcvmnyNotificationreportMno: this.kouzaDepositreportMeisai.rcvmnyNotificationreportMno || null,
      // 入金通知報告履歴番号
      rcvmnyNotificationreportRrkno: this.kouzaDepositreportMeisai.rcvmnyNotificationreportRrkno || null,
      // 入金通知報告_更新通番号
      rcvmnyNotificationreportUpdatesequencenumber: this.kouzaDepositreportMeisai.rcvmnyNotificationreportUpdatesequencenumber || null,
      // 訂正フラグ
      isEdit: isEdit,
    };

    // エラーメッセージを非表示に切替
    this.onModalIsDisplay(false);


    // SGKE110D_入金通知報告画面モーダル表示
    const ref = this.dialog.open(Sgke110dDialogComponent, {
      maxHeight: '95vh',
      width: '1000px',
      disableClose: true, // 背景クリックのクローズ禁止
      data: dataObject,
    });

    // モーダルウィンドウを閉じた後の処理
    ref.afterClosed().subscribe(res => {
      if (res) {
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(res, this.errorMessageModelArray);
      }
      // エラーメッセージを表示に切替
      this.onModalIsDisplay(true);
      // 初期表示
      this.init();

    });

  }

  /**
   * 入金突合明細画面遷移処理（手数料登録／手数料訂正ボタン押下時）
   * 
   * @param {boolean} isEdit
   * @memberof Sgke130dComponent
   */
  navigateToFeeReportOnClickRegist(isEdit: boolean) {

    // メッセージクリア
    this.clearErrorMsg();

    /** ダイアログに渡すデータオブジェクト */
    let dataObject = {
      // 入金突合結果管理番号
      rcvmnyReconciliationresultMno: this.basicInfo.rcvmnyReconciliationresultMno || null,
      // 入金突合結果_更新通番号
      rcvmnyreconciliationResultUpdatesequencenumber: this.basicInfo.rcvmnyreconciliationResultUpdatesequencenumber || null,
      // 手数料管理番号
      feeMno: this.rcvmnyFeeMeisai.feeMno || null,
      // 手数料履歴番号
      feeRrkno: this.rcvmnyFeeMeisai.feeRrkno || null,
      // 手数料_更新通番号
      feeUpdatesequencenumber: this.rcvmnyFeeMeisai.feeUpdatesequencenumber || null,
      // 訂正フラグ
      isEdit: isEdit,
    };

    // エラーメッセージを非表示に切替
    this.onModalIsDisplay(false);

    const ref = this.dialog.open(Sgke140dDialogComponent, {
      maxHeight: '95vh',
      width: '1000px',
      disableClose: true, // 背景クリックのクローズ禁止
      data: dataObject,
    });

    // モーダルウィンドウを閉じた後の処理
    ref.afterClosed().subscribe(res => {
      if (res) {
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(res, this.errorMessageModelArray);
      }
      // エラーメッセージを表示に切替
      this.onModalIsDisplay(true);
      // 初期表示
      this.init();

    });

  }

  /**
   * モーダル表示非表示イベント時処理
   * @param {boolean} isDisplay
   * @memberof Sgke130dComponent
   */
  private onModalIsDisplay(isDisplay: boolean): void {
    // エラーメッセージ表示エリア表示非表示を切替
    this.isErrMssageDisplay = isDisplay;
  };

  /**
   * 報告処理
   * 
   * @memberof Sgke130dComponent
   */
  regist() {
    // メッセージクリア
    this.clearErrorMsg();

    if (this.mode == this.MODE_APPROVE) {
      this.approval();
    } else {
      this.report();
    }
  }

  /**
   * 報告ボタン活性非活性判定
   *
   * @returns {boolean} true:非活性、false:活性
   * @memberof Sgke130dComponent
   */
  isReportButtonDisabled(): boolean {

    if (this.basicInfo?.reconciliationStatuscode == this.RECONCILIATION_STATUSCODE_APPROVED ) {
      // 入金突合ステータスが承認済の場合、非活性
      return true;
    }

    if (this.kouzaDepositreportMeisai?.rcvmnyNotificationreportMno == null && this.rcvmnyFeeMeisai?.feeMno == null) {
      // 口座入金報告明細、入金手数料明細が存在しない場合、非活性
      return true;
    }

    return false;
  }

  /**
   * 承認ボタン活性非活性判定
   *
   * @returns {boolean} true:非活性、false:活性
   * @memberof Sgke130dComponent
   */
  isApproveButtonDisabled(): boolean {

    if (this.basicInfo?.reconciliationStatuscode && this.basicInfo?.reconciliationStatuscode != this.RECONCILIATION_STATUSCODE_REPORTED) {
      // 入金突合ステータスが報告済以外の場合、非活性
      return true;
    }

    return false;
  }

  /**
   * 前画面に戻る
   * 
   * @memberof Sgke130dComponent
   */
  public goToPrevious(): void {
    this.returnFlg = true;
    this.router.navigate(['sgke/sgke120d', { mode: this.mode }]);
  }

  /**
   * 初期処理
   * @private
   * @memberof Sgke130dComponent
   */
  private init() {

    // 検索結果初期化
    this.basicInfo = null;
    this.reconciliationResult = null;
    this.receivemoneyyoteiMeisaiList = null;
    this.kouzaDepositreportMeisai = null;
    this.rcvmnyFeeMeisai = null;
    this.bikoran = null;

    // sgke131aのリクエスト情報をもつオブジェクトを定義
    let request131a: Sgke131aRequest = {
      // UsedService側で設定するため、ここではnullを設定する
      requestCommon: null,
      rcvmnyreconciliationDataSelectinfo: {
        // 入金突合結果管理番号
        rcvmnyReconciliationresultMno: this.rcvmnyReconciliationresultMno,
      }
    };

    // SGKE131A呼び出し
    this.initService.doSgke131a(request131a).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response?.initialhyojiInfo) {
          this.basicInfo = response.initialhyojiInfo.basicInfo;
          this.reconciliationResult = response.initialhyojiInfo.reconciliationResult;
          this.receivemoneyyoteiMeisaiList = response.initialhyojiInfo.receivemoneyyoteiMeisaiList;
          this.kouzaDepositreportMeisai = response.initialhyojiInfo.kouzaDepositreportMeisai;
          this.rcvmnyFeeMeisai = response.initialhyojiInfo.rcvmnyFeeMeisai;
          this.bikoran = response.initialhyojiInfo.bikoran;
        }
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      },
      error => {
      });
  }

  /**
   * 報告処理
   * 
   * @memberof Sgke130dComponent
   */
  private report() {

    // 備考フォーム
    const bikoranForm = this.parentForm.get('bikoranForm').value;

    // 報告リクエストDTO作成
    let request: Sgke132aRequest = {
      // requestCommonはUsedService側で設定するため、ここではnullを設定する
      requestCommon: null,
      // 報告情報
      reportInfo: {
        // 入金突合結果管理番号
        rcvmnyReconciliationresultMno: this.basicInfo.rcvmnyReconciliationresultMno,
        // 入金突合結果_更新通番号
        rcvmnyreconciliationResultUpdatesequencenumber: this.basicInfo.rcvmnyreconciliationResultUpdatesequencenumber,
        // 入金通知報告管理番号
        rcvmnyNotificationreportMno: this.kouzaDepositreportMeisai.rcvmnyNotificationreportMno,
        // 入金通知報告履歴番号
        rcvmnyNotificationreportRrkno: this.kouzaDepositreportMeisai.rcvmnyNotificationreportRrkno,
        // 手数料管理番号
        feeMno: this.rcvmnyFeeMeisai.feeMno,
        // 手数料履歴番号
        feeRrkno: this.rcvmnyFeeMeisai.feeRrkno,
        // 入金突合ステータスコード
        rcvmnyReconciliationStatuscode: this.basicInfo.reconciliationStatuscode,
        // 過不足金額
        kafusokuMny: this.reconciliationResult.kafusokuMny,
        // 備考
        biko: bikoranForm.biko?.trim() ? bikoranForm.biko : null,
      }
    }

    // SGKE132A呼び出し
    this.reportService.doSgke132a(request).pipe(takeUntil(this.onDestroy$))
      .subscribe(
        this.handleRegistResponse,
        error => {
        });
  }

  /**
   * 承認処理
   * 
   * @memberof Sgke130dComponent
   */
  private approval() {

    // 承認リクエストDTO作成
    let request: Sgke133aRequest = {
      // requestCommonはUsedService側で設定するため、ここではnullを設定する
      requestCommon: null,
      apprvInfo: {
        // 入金突合結果管理番号
        rcvmnyReconciliationresultMno: this.basicInfo.rcvmnyReconciliationresultMno,
        // 入金突合結果_更新通番号
        rcvmnyreconciliationResultUpdatesequencenumber: this.basicInfo.rcvmnyreconciliationResultUpdatesequencenumber,
        // 入金突合ステータスコード
        rcvmnyReconciliationStatuscode: this.basicInfo.reconciliationStatuscode,
      }
    }

    // SGKE133A呼び出し
    this.approvalService.doSgke133a(request).pipe(takeUntil(this.onDestroy$))
      .subscribe(
        this.handleRegistResponse,
        error => {
        });
  }


  /**
   * エラーメッセージ表示領域をクリア
   * @private
   * @memberof Sgke130dComponent
   */
  private clearErrorMsg() {
    this.errorMessageModelArray = new Array<SgAriaMessage>();
    this.cd.detectChanges();
  }

  /**
   * レスポンス共通処理
   * 
   * @private
   * @param {any} response 
   * @memberof Sgke130dComponent
   */
  private handleRegistResponse = (response: any): void => {
    if (response) {
      // 登録完了画面情報設定
      this.completeDataService.completeData = {
        title: this.mode == this.MODE_APPROVE ? '入金突合明細承認完了画面' : '入金突合明細報告完了画面',
        message: this.mode == this.MODE_APPROVE ? '入金突合明細を承認しました' : '入金突合明細を報告しました',
        next: 'sgke/sgke120d',
        queryParams: { mode: this.mode }
      };
      // 登録完了画面遷移
      this.router.navigate(['/sgkz003d/'])
      this.returnFlg = true;
    }
  }

}